
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class TbTable extends Vue {
    //骰宝
    table = {
        data: [],
        column: [
            {
                key: 'da',
                title: '下注大',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.da) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.da.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'xiao',
                title: '下注小',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.xiao) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.xiao.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '下注组合',
                align: 'center',
                minWidth: 90,
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.includes('zuhe')) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'shuang_1',
                title: '下注双骰',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.indexOf('shuang_') > -1) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'baozi_5',
                title: '下注围骰',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key != 'baozi_a') {
                                if (key.includes('baozi_')) {
                                    str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                                }
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '下注全围',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.baozi_a) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.baozi_a.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '下注单点',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.includes('dan')) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '下注点数和',
                align: 'center',
                minWidth: 90,
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.includes('hezhi_')) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '点数',
                align: 'center',
                minWidth: 150,
                render: (h, params) => {
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        str = JSON.parse(params.row.opt_detail).award_content.point.poker
                    }
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: str.map((x) => {
                                return "<img style='width:35px;' src=img/poker/tb_" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                minWidth: 70,
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }
    //骰宝组合型
    getType(type) {
        let arr: any = [
            { key: 'baozi_1', name: '围骰1:' },
            { key: 'baozi_2', name: '围骰2:' },
            { key: 'baozi_3', name: '围骰3:' },
            { key: 'baozi_4', name: '围骰4:' },
            { key: 'baozi_5', name: '围骰5:' },
            { key: 'baozi_6', name: '围骰6:' },
            { key: 'shuang_1', name: '1点:' },
            { key: 'shuang_2', name: '2点:' },
            { key: 'shuang_3', name: '3点:' },
            { key: 'shuang_4', name: '4点:' },
            { key: 'shuang_5', name: '5点:' },
            { key: 'shuang_6', name: '6点:' },
            { key: 'zuhe_1_2', name: '组合1-2:' },
            { key: 'zuhe_1_3', name: '组合1-3:' },
            { key: 'zuhe_1_4', name: '组合1-4:' },
            { key: 'zuhe_1_5', name: '组合1-5:' },
            { key: 'zuhe_1_6', name: '组合1-6:' },
            { key: 'zuhe_2_3', name: '组合2-3:' },
            { key: 'zuhe_2_4', name: '组合2-4:' },
            { key: 'zuhe_2_5', name: '组合2-5:' },
            { key: 'zuhe_2_6', name: '组合2-6:' },
            { key: 'zuhe_3_4', name: '组合3-4:' },
            { key: 'zuhe_3_5', name: '组合3-5:' },
            { key: 'zuhe_3_6', name: '组合3-6:' },
            { key: 'zuhe_4_5', name: '组合4-5:' },
            { key: 'zuhe_4_6', name: '组合4-6:' },
            { key: 'zuhe_5_6', name: '组合5-6:' },
            { key: 'hezhi_4', name: '和值4:' },
            { key: 'hezhi_5', name: '和值5:' },
            { key: 'hezhi_6', name: '和值6:' },
            { key: 'hezhi_7', name: '和值7:' },
            { key: 'hezhi_8', name: '和值8:' },
            { key: 'hezhi_9', name: '和值9:' },
            { key: 'hezhi_10', name: '和值10:' },
            { key: 'hezhi_11', name: '和值11:' },
            { key: 'hezhi_12', name: '和值12:' },
            { key: 'hezhi_13', name: '和值13:' },
            { key: 'hezhi_14', name: '和值14:' },
            { key: 'hezhi_15', name: '和值15:' },
            { key: 'hezhi_16', name: '和值16:' },
            { key: 'hezhi_17', name: '和值17:' },
            { key: 'dan_1', name: '单1:' },
            { key: 'dan_2', name: '单2:' },
            { key: 'dan_3', name: '单3:' },
            { key: 'dan_4', name: '单4:' },
            { key: 'dan_5', name: '单5:' },
            { key: 'dan_6', name: '单6:' }
        ]
        return arr.find((el) => el.key == type).name || ''
    }

    @Prop()
    listdata
}
